import React, { memo, useCallback } from 'react';
import { cn } from 'lib/utils';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

function Switch(props: Props) {
  const { checked, onChange, className = '' } = props;

  const onChangeCheckbox = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.checked);
    },
    [onChange]
  );

  return (
    <label
      className={cn(
        'relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-primary' : 'bg-input',
        className
      )}
    >
      <input
        className="sr-only"
        type="checkbox"
        onChange={onChangeCheckbox}
        checked={checked}
      />
      <span
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform',
          checked ? 'translate-x-6' : 'translate-x-1'
        )}
      />
    </label>
  );
}

export default memo(Switch);
